import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex'
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto'
    },
    container: {
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(5)
    }
}));

/**
 * @param component
 * @returns {XMLList}
 * @constructor
 */
export default function Chrome({
    component: Component,
    routeProps = {}
}) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <CssBaseline />
            <Header />
            <Sidebar />
            <main className={classes.content}>
                <div className={classes.appBarSpacer} />
                <div className={classes.container}>
                    <Component {...routeProps} />
                </div>
            </main>
        </div>
    );
}

Chrome.propTypes = {
    component: PropTypes.object.isRequired
};